<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('report.multiple_import')}}</div>
    <div slot="body">
      <a-form
        :form="form.fc">
        <template v-if="this.params.resourceTypeData.parent_id">
          <a-form-item :label="$t('report.parent_resource_type')" v-bind="formItemLayout">
            {{ params.resourceTypeData.parent_name }}
          </a-form-item>
          <a-form-item :label="$t('report.associate_field')" v-bind="formItemLayout">
            <base-select
              v-model="associate_field"
              :options="parentAttributes"
              :select-props="{placeholder: $t('common.tips.select', [$t('network.select_associate_field')]), allowClear: true}" />
          </a-form-item>
        </template>
        <a-alert type="warning" class="mb-2">
          <template v-slot:message>
            <div class="messages-list">
              <p>{{ $t('network.import_tpl_tips') }}<a-button type="link" @click="handleDownloadTemplate">{{$t('network.download_tpl')}}</a-button></p>
            </div>
          </template>
        </a-alert>
        <div class="pt-3 pb-3">
          <a-form-item>
            <a-upload-dragger
              v-decorator="decorators.fileList"
              :beforeUpload="beforeUpload"
              :fileList="fileList"
              :accept="accept"
              :remove="handleRemove">
              <div class="pt-3 pb-3">
                <p class="ant-upload-drag-icon"><a-icon type="inbox" /></p>
                <p class="ant-upload-text">{{$t('network.drag_file_area')}}</p>
                <p class="ant-upload-hint">{{$t('network.file_type_validate')}}</p>
              </div>
            </a-upload-dragger>
          </a-form-item>
        </div>
     </a-form>
     <template v-if="errorData.length > 0">
      <div style="color:red">{{ $t('report.import_error') }}</div>
      <vxe-table border :data="errorData">
        <vxe-table-column field="seq" width="50px" :title="$t('report.data_seq')" />
        <vxe-table-column field="key" :title="$t('report.data_col')" />
        <vxe-table-column field="msg" :title="$t('report.error_message')" />
      </vxe-table>
     </template>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import * as R from 'ramda'
import XLSX from 'xlsx'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import { Manager } from '@/utils/manager'
import { FIELD_TYPE_PARSER } from '../constants'

export default {
  name: 'ImportReportCustomDataDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    const { attributes = [] } = this.params.resourceTypeData
    return {
      accept: '.xlsx',
      fileList: [],
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      decorators: {
        fileList: ['fileList', {
          rules: [
            { required: true, message: this.$t('network.import_tpl_file') },
          ],
        }],
      },
      attributes,
      titleList: attributes.map(item => `${item.name}${item.unit ? `(${item.unit})` : ''}`),
      temList: attributes.map(item => this.getTemText(item)),
      parentAttributes: [],
      associate_field: null,
      errorData: [],
    }
  },
  created () {
    this.$eM = new this.$Manager('ext_resource_types', 'v1')
    this.fetchParentAttributes()
  },
  methods: {
    getTemText (col) {
      if (col.value_type === 0 && col.choices) {
        return col.choices.join('，')
      } else if (col.value_type === 4) {
        return 'YYYY/MM/DD, YYYY-MM-DD'
      } else if (col.value_type === 5) {
        return 'YYYY-MM-DD HH:mm:ss'
      }
      return ''
    },
    fetchParentAttributes () {
      if (this.params.resourceTypeData.parent_id) {
        this.$eM.get({ id: this.params.resourceTypeData.parent_id, details: true }).then(res => {
          const { attributes = [] } = res.data
          this.parentAttributes = attributes.filter(item => item.is_uniq).map(item => ({ id: `${item.name}${item.unit ? `(${item.unit})` : ''}`, name: `${item.name}${item.unit ? `(${item.unit})` : ''}` }))
        })
      }
    },
    beforeUpload (file) {
      this.fileList = [file]
      this.errorData = []
      return false
    },
    handleClearFile () {
      this.fileList = []
      this.errorData = []
    },
    handleRemove () {
      this.handleClearFile()
    },
    handleDownloadTemplate () {
      const { name = 'template', parent_name } = this.params.resourceTypeData
      const titleList = this.titleList
      titleList.push('项目ID')
      if (this.associate_field) {
        titleList.push(`$${parent_name}.${this.associate_field}`)
      }
      const data = [
        [...titleList],
        [...this.temList],
      ]
      const filename = `${name}.xlsx`
      const ws_name = 'Sheet1'
      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.aoa_to_sheet(data)
      XLSX.utils.book_append_sheet(wb, ws, ws_name)
      XLSX.writeFile(wb, filename)
    },
    async doCreate (sheetData) {
      try {
        const manager = new Manager(`ext_resource_types/${this.params.resourceTypeData.id}/import`, 'v1')
        const data = []
        // const hasEmpty = false
        sheetData.map(item => {
          const ret = {}
          this.titleList.map((title, index) => {
            const targets = this.attributes.filter(item => `${item.name}${item.unit ? `(${item.unit})` : ''}` === title)
            if (targets[0] && targets[0].value_type + '' === '4') {
              ret[targets[0].name] = item[title] ? FIELD_TYPE_PARSER.date.parse(item[title]) + '' : ''
            } else if (targets[0] && targets[0].value_type + '' === '5') {
              ret[targets[0].name] = item[title] ? FIELD_TYPE_PARSER.time.parse(item[title]) + '' : ''
            } else if (targets[0]) {
              ret[targets[0].name] = (item[title] ? item[title] + '' : '').trim()
            }
          })
          const keys = Object.keys(item).filter(key => key.startsWith('$'))
          if (keys.length) {
            keys.map(key => {
              ret[key] = item[key]
            })
          }
          if (item['项目ID']) {
            ret.tenant_id = item['项目ID']
          }
          if (item['域'] || item.domain_name) {
            ret.domain_name = item['域'] || item.domain_name
          }
          if (item['项目名称'] || item.tenant_name) {
            ret.tenant_name = item['项目名称'] || item.tenant_name
          }
          data.push(ret)
        })
        const res = await manager.create({
          data: {
            data,
          },
        })
        const { data: resData } = res
        if (R.is(Array, resData)) {
          // error
          this.errorData = resData.map(item => {
            return {
              seq: item.row + 2,
              msg: item.message,
              key: item.key,
            }
          })
        } else {
          this.cancelDialog()
          this.$message.success(this.$t('common.success'))
          this.params.ok && this.params.ok()
        }
      } catch (error) {
        throw error
      }
    },
    async handleConfirm () {
      try {
        if (!this.fileList || this.fileList.length === 0) {
          this.form.fc.setFieldsValue({
            fileList: undefined,
          })
        }
        const that = this
        await this.form.fc.validateFields()
        this.loading = true
        var fileReader = new FileReader()
        fileReader.onload = async function (ev) {
          try {
            var data = ev.target.result
            var workbook = XLSX.read(data, {
              type: 'binary',
            }) // 以二进制流方式读取得到整份excel表格对象
            var sheetData = [] // 存储获取到的数据
          } catch (e) {
            throw e
          }
          for (var sheet in workbook.Sheets) {
            if (workbook.Sheets.hasOwnProperty(sheet)) {
              sheetData = sheetData.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]))
            }
          }
          that.doCreate(sheetData)
        }
        // 以二进制方式打开文件
        fileReader.readAsBinaryString(this.fileList[0])
      } catch (err) {
        throw err
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
  .messages-list p{
    margin-bottom: 2px;
  }
</style>
